import { AnalysisItem, LegendItem } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import getColor from "report/common/color";
import getLayer from "report/common/layer";
import getRect from "report/common/rect";
import layout from "report/common/layout";
import getOutside from "report/common/outside";
import getMatchingTitle from "components/fathomAnalyze/util";

const get = (
  t: any,
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[]
): Content => {
  const row = analysisItems.map((e) => {
    const legend = legendItems.find((i) => e.layerId === i.layerId);

    if (!legend || !legend.rules || !legend.rules.length) {
      return [];
    }

    const exclude = ["No Data", "Outside", "No Observation"];
    const rules = legend.rules.filter((e) => !exclude.includes(e.title));

    const index = rules.findIndex(
      (item) =>
        item.title === e.valueLabel ||
        item.title ===
          getMatchingTitle(e.valueLabel.replace("years", "").replace(" ", ""))
    );

    const colorArray = getColor(rules);
    const grey = ["Outside", "No Observation", "Waterbody"];
    const fillColor = e.valueLabel === "Waterbody" ? "#DCDBDC" : "#D3D3D3";

    return [
      getLayer(t, e.layerId),
      grey.includes(e.valueLabel)
        ? getOutside(fillColor)
        : getRect(colorArray, index),
      t("legend." + e.valueLabel)
    ];
  });

  return {
    table: {
      widths: [200, 237, 100],
      body: [
        [
          { text: t("report.hazard") },
          { text: t("fathom.Hazard Risk") },
          { text: "" }
        ],
        ...row
      ]
    },
    layout: layout(row.length + 2, false, 3),
    fontSize: 8,
    opacity: 0.6,
    lineHeight: 1,
    characterSpacing: 0
  };
};

export default get;
